export class Zone {

  constructor(
    private id: string,
    private label: string,
  ) {
  }

  static deserialize(dto: ZoneDto): Zone {
    return new Zone(dto.id, dto.label);
  }

  getId(): string {
    return this.id;
  }

  hasId(id): boolean {
    return this.getId() === id;
  }

  getLabel(): string {
    return this.label;
  }
}

export interface ZoneDto {
  id: string;
  label: string;
}
